/**
 * Generated by orval 🍺
 * Supplier Backend API
 * API Endpoint for Supplier
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  V1SetupGet200
} from '../../model';

import { customSaasInstance } from '../../../customSaasInstance';
import type { ErrorType } from '../../../customSaasInstance';




/**
 * Get all meta fields
 * @summary Get all meta fields
 */
export const v1SetupGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customSaasInstance<V1SetupGet200>(
      {url: `/v1/setup`, method: 'GET', signal
    },
      );
    }
  



export const getV1SetupGetQueryKey = () => {
    return [
    `/v1/setup`
    ] as const;
    }

    
export const getV1SetupGetQueryOptions = <TData = Awaited<ReturnType<typeof v1SetupGet>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SetupGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SetupGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SetupGet>>> = ({ signal }) => v1SetupGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SetupGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1SetupGetQueryResult = NonNullable<Awaited<ReturnType<typeof v1SetupGet>>>
export type V1SetupGetQueryError = ErrorType<unknown>


export function useV1SetupGet<TData = Awaited<ReturnType<typeof v1SetupGet>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SetupGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SetupGet>>,
          TError,
          Awaited<ReturnType<typeof v1SetupGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SetupGet<TData = Awaited<ReturnType<typeof v1SetupGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SetupGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SetupGet>>,
          TError,
          Awaited<ReturnType<typeof v1SetupGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SetupGet<TData = Awaited<ReturnType<typeof v1SetupGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SetupGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all meta fields
 */

export function useV1SetupGet<TData = Awaited<ReturnType<typeof v1SetupGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SetupGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1SetupGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




